import {
  Body1,
  Button,
  Caption1,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  makeStyles,
} from "@fluentui/react-components";
import { ArrowReplyRegular, ShareRegular } from "@fluentui/react-icons";
import React from "react";
import Section from "./Section";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    marginTop: "10px",
    marginBottom: "20px",
    width: "1500px", // Default width
    maxWidth: "100%",
    borderTop: "4px solid rgb(0, 96, 168)",
  },
  cardWithSidebar: {
    margin: "auto",
    marginTop: "20px",
    marginBottom: "20px",
    width: "1500px", // Width when sidebar is present
    maxWidth: "100%",
    borderTop: "4px solid rgb(0, 96, 168)",
  },
});

interface Props {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  sidebar?: React.ReactNode;
  children?: React.ReactNode;
}
const Page = ({ sidebar, children, header, footer }: Props) => {
  const styles = useStyles();
  const cardClassName = sidebar ? styles.cardWithSidebar : styles.card;

  return (
    <Card className={cardClassName}>
      {header ? (
        <CardHeader
          header={
            <Body1>
              <b>Elvia Atkins</b> mentioned you
            </Body1>
          }
          description={<Caption1>5h ago · About us - Overview</Caption1>}
        />
      ) : undefined}
      <CardPreview>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {sidebar && sidebar}
          {/* Main content area */}
          <div style={{ flexGrow: 1 }}>{children}</div>
        </div>
      </CardPreview>

      {/* <CardFooter>
        {footer ?? undefined}
      </CardFooter> */}
    </Card>
  );
};

export default Page;
